/* OFT Chair Finder — works with wizard HTML in layout/theme.liquid */
(function () {
  'use strict';

  var answers = {};
  var TOTAL = 5;

  /* ── Open / Close ── */
  window.oftWizOpen = function () {
    var el = document.getElementById('oft-wiz-overlay');
    if (!el) return;
    el.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    oftWizReset();
    oftWizShowStep(1);
  };

  window.oftWizClose = function () {
    var el = document.getElementById('oft-wiz-overlay');
    if (!el) return;
    el.style.display = 'none';
    document.body.style.overflow = '';
  };

  window.oftWizReset = function () {
    answers = {};
    document.querySelectorAll('.oft-opt').forEach(function (o) { o.classList.remove('selected'); });
    for (var i = 1; i <= TOTAL; i++) {
      var nb = document.getElementById('oft-next-' + i);
      if (nb) nb.disabled = true;
    }
    var quiz = document.getElementById('oft-wiz-quiz');
    var res = document.getElementById('oft-wiz-results');
    if (quiz) quiz.style.display = 'block';
    if (res) { res.style.display = 'none'; res.innerHTML = ''; }
  };

  window.oftWizShowStep = function (n) {
    for (var i = 1; i <= TOTAL; i++) {
      var s = document.getElementById('oft-step-' + i);
      if (s) s.style.display = (i === n) ? 'block' : 'none';
    }
    var numEl = document.getElementById('oft-wiz-stepnum');
    if (numEl) numEl.textContent = n;
    for (var j = 1; j <= TOTAL; j++) {
      var p = document.getElementById('oft-prog-' + j);
      if (p) p.classList.toggle('done', j < n);
    }
    var modal = document.querySelector('#oft-wiz-overlay > div');
    if (modal) modal.scrollTop = 0;
  };

  /* ── Option clicks ── */
  function bindOptions() {
    document.querySelectorAll('.oft-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step;
        var val = btn.dataset.val;
        /* Deselect others in same step */
        document.querySelectorAll('.oft-opt[data-step="' + step + '"]').forEach(function (o) {
          o.classList.remove('selected');
        });
        btn.classList.add('selected');
        answers[step] = val;
        var nb = document.getElementById('oft-next-' + step);
        if (nb) nb.disabled = false;
      });
    });
  }

  /* ── Next buttons ── */
  function bindNav() {
    for (var i = 1; i <= TOTAL; i++) {
      (function (step) {
        var nb = document.getElementById('oft-next-' + step);
        if (!nb) return;
        nb.addEventListener('click', function () {
          if (step < TOTAL) {
            oftWizShowStep(step + 1);
          } else {
            fetchAndShowResults();
          }
        });
      })(i);
    }
  }

  /* ── Fetch products via AJAX ── */
  function fetchCollection(handle, limit, cb) {
    fetch('/collections/' + handle + '/products.json?limit=' + (limit || 50))
      .then(function (r) { return r.json(); })
      .then(function (d) { cb(null, d.products || []); })
      .catch(function () { cb(null, []); });
  }

  function isRefurb(p) {
    return (p.tags || []).some(function (t) {
      var tl = t.toLowerCase();
      return tl === 'hn-cer' || tl === 'hnused';
    });
  }

  function hasTag(tags, words) {
    var tl = (tags || []).map(function (t) { return t.toLowerCase(); });
    return words.some(function (w) {
      return tl.some(function (t) { return t.indexOf(w) !== -1; });
    });
  }

  function scoreProduct(p, ans) {
    var score = 0;
    var tags = p.tags || [];
    var title = (p.title || '').toLowerCase();
    var refurb = isRefurb(p);
    var price = parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0);

    var hours = ans['1'], usage = ans['2'], support = ans['3'], material = ans['4'], budget = ans['5'];

    /* Hours */
    if ((hours === '7to8' || hours === '8plus') && hasTag(tags, ['ergonomic', 'lumbar', '8 hour', 'task chair for 8'])) score += 3;
    if ((hours === '1to3' || hours === '4to6') && !hasTag(tags, ['24 hour'])) score += 1;

    /* Usage */
    if (usage === 'home' && (title.indexOf('home') !== -1 || hasTag(tags, ['home office']))) score += 2;
    if (usage === 'fulltime' && hasTag(tags, ['ergonomic', 'task', 'operator'])) score += 2;
    if (usage === 'callcentre' && hasTag(tags, ['operator', 'task', 'operator chairs'])) score += 2;
    if (usage === 'executive' && (hasTag(tags, ['executive']) || title.indexOf('executive') !== -1)) score += 3;
    if (usage === 'meeting' && hasTag(tags, ['meeting', 'visitor', 'conference'])) score += 3;
    if (usage === 'bulk') score += 1;

    /* Support */
    if (support === 'lumbar' && hasTag(tags, ['lumbar', 'adjustable lumbar'])) score += 3;
    if (support === 'posture' && hasTag(tags, ['posture', 'ergonomic'])) score += 2;
    if (support === 'arms' && hasTag(tags, ['adjustable armrest', '4d arm', 'adjustable arm'])) score += 2;
    if (support === 'headrest' && (title.indexOf('headrest') !== -1 || hasTag(tags, ['headrest']))) score += 3;
    if (support === 'padded' && (title.indexOf('fabric') !== -1 || hasTag(tags, ['fabric', 'padded']))) score += 2;
    if (support === 'mesh' && (title.indexOf('mesh') !== -1 || hasTag(tags, ['mesh']))) score += 3;

    /* Material */
    if (material === 'mesh' && (title.indexOf('mesh') !== -1 || hasTag(tags, ['mesh']))) score += 3;
    if (material === 'fabric' && (title.indexOf('fabric') !== -1 || hasTag(tags, ['fabric']))) score += 2;
    if (material === 'leather' && (title.indexOf('leather') !== -1 || hasTag(tags, ['leather', 'executive']))) score += 3;
    if (material === 'reupholstered' && refurb) score += 3;
    if (material === 'nopref') score += 1;

    /* Budget */
    if (budget === 'under100') { if (price <= 100) score += 4; else if (price <= 150) score += 1; }
    if (budget === '100to200') { if (price >= 100 && price <= 200) score += 4; else score += 1; }
    if (budget === '200to350') { if (price >= 200 && price <= 350) score += 4; else if (price >= 150) score += 1; }
    if (budget === '350plus' || budget === 'bulk') { if (price >= 350) score += 4; else if (price >= 200) score += 2; }

    /* Refurb bonus for intensive use at good price */
    if (refurb && (hours === '7to8' || hours === '8plus') && price >= 200) score += 2;

    return score;
  }

  function matchBadge(p, ans) {
    var tags = p.tags || [];
    var title = (p.title || '').toLowerCase();
    var price = parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0);
    var refurb = isRefurb(p);
    if (refurb && price >= 300) return 'Best refurbished premium chair';
    if (refurb) return 'Best refurbished value chair';
    if ((ans['1'] === '8plus') && hasTag(tags, ['ergonomic', 'lumbar', '8 hour'])) return 'Best for 8-hour use';
    if (ans['2'] === 'executive' || hasTag(tags, ['executive'])) return 'Best executive chair';
    if (ans['5'] === 'under100') return 'Best budget chair';
    if (ans['2'] === 'bulk') return 'Best for bulk fit-outs';
    if (hasTag(tags, ['posture', 'lumbar'])) return 'Best for posture support';
    if (title.indexOf('mesh') !== -1) return 'Best breathable mesh chair';
    return 'Recommended match';
  }

  function reasonText(p, ans) {
    var tags = p.tags || [];
    var title = (p.title || '').toLowerCase();
    var refurb = isRefurb(p);
    var parts = [];
    if (refurb) parts.push('quality-checked refurbished');
    if (title.indexOf('mesh') !== -1 || hasTag(tags, ['mesh'])) parts.push('breathable mesh back');
    if (hasTag(tags, ['lumbar', 'lumbar support'])) parts.push('lumbar support');
    if (hasTag(tags, ['ergonomic'])) parts.push('ergonomic design');
    if (hasTag(tags, ['adjustable armrest', '4d arm'])) parts.push('adjustable arms');
    if (hasTag(tags, ['executive']) || title.indexOf('executive') !== -1) parts.push('executive styling');
    if (parts.length === 0) return 'A close match based on your requirements.';
    return 'Features ' + parts.slice(0, 3).join(', ') + ' \u2014 matched to your answers.';
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(v) {
    var n = parseFloat(v || 0);
    return isNaN(n) ? '' : '\u00a3' + n.toFixed(2).replace(/\.00$/, '');
  }

  function fetchAndShowResults() {
    var quiz = document.getElementById('oft-wiz-quiz');
    var res = document.getElementById('oft-wiz-results');
    if (quiz) quiz.style.display = 'none';
    if (res) {
      res.style.display = 'block';
      res.innerHTML = '<div style="text-align:center;padding:36px 20px"><div class="oft-spinner"></div><p style="color:#666;font-size:14px">Finding your best chair matches\u2026</p></div>';
    }
    var modal = document.querySelector('#oft-wiz-overlay > div');
    if (modal) modal.scrollTop = 0;

    var all = [], done = 0;
    function onFetch(err, products) {
      all = all.concat(products || []);
      done++;
      if (done === 2) buildResults(all);
    }
    fetchCollection('certified-pre-owned-ergonomic-chairs', 50, onFetch);
    fetchCollection('office-chairs', 50, onFetch);
  }

  function buildResults(all) {
    /* De-dupe */
    var seen = {}, products = [];
    all.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = true; products.push(p); } });

    /* Score and sort */
    var scored = products.map(function (p) { return { p: p, s: scoreProduct(p, answers) }; });
    scored.sort(function (a, b) { return b.s - a.s; });
    var top = scored.slice(0, 5).filter(function (x) { return x.s > 0; });
    if (!top.length) top = scored.slice(0, 3);

    var res = document.getElementById('oft-wiz-results');
    if (!res) return;

    if (!top.length) {
      res.innerHTML = '<div style="padding:24px;text-align:center;color:#888">No products found. Please <a href="/pages/contact-us" style="color:#df6060">contact our team</a> for a personal recommendation.</div>';
      return;
    }

    var html = '<h3 style="font-size:16px;font-weight:700;color:#121212;margin:0 0 4px">Your recommended chairs</h3>' +
      '<p style="font-size:13px;color:#555;margin:0 0 16px">Based on your answers, here are our top ' + top.length + ' matches from our live stock.</p>';

    top.forEach(function (item, idx) {
      var p = item.p;
      var refurb = isRefurb(p);
      var price = (p.variants && p.variants[0] && p.variants[0].price) || '0';
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var url = '/products/' + p.handle;
      var badge = matchBadge(p, answers);
      var reason = reasonText(p, answers);
      var shortTitle = p.title.length > 70 ? p.title.substring(0, 68) + '\u2026' : p.title;
      var condBadge = refurb ? '<span class="oft-badge-refurb">Refurbished</span>' : '<span class="oft-badge-new">New</span>';

      var cmpCall = 'oftCmpAdd(' +
        JSON.stringify(String(p.id)) + ',' +
        JSON.stringify(p.title) + ',' +
        JSON.stringify(String(price)) + ',' +
        JSON.stringify(img) + ',' +
        JSON.stringify(url) + ',' +
        JSON.stringify(refurb ? 'Refurbished' : 'New') + ',' +
        JSON.stringify(p.vendor || '') + ',' +
        JSON.stringify(p.tags || []) +
        ')';

      html += '<div class="oft-rec-card' + (idx === 0 ? ' top' : '') + '">' +
        (img ? '<img class="oft-rec-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<div class="oft-rec-img"></div>') +
        '<div class="oft-rec-body">' +
          '<div class="oft-rec-badges">' + condBadge + '<span class="oft-badge-match">' + esc(badge) + '</span></div>' +
          '<p class="oft-rec-name">' + esc(shortTitle) + '</p>' +
          '<p class="oft-rec-price">' + money(price) + '</p>' +
          '<p class="oft-rec-reason">' + esc(reason) + '</p>' +
          '<div class="oft-rec-actions">' +
            '<a href="' + url + '" class="oft-rec-view">View Chair</a>' +
            '<button class="oft-rec-cmp" onclick="' + esc(cmpCall) + '" type="button">+ Add to Compare</button>' +
          '</div>' +
        '</div></div>';
    });

    /* Disclaimer */
    html += '<div style="background:#f9f9f9;border:1px solid #e8e8e8;border-radius:8px;padding:10px 13px;font-size:11px;color:#888;line-height:1.55;margin:14px 0">' +
      '<strong style="color:#555">Please note:</strong> These are suggestions based on your answers and are not a guarantee of suitability. ' +
      'Please read full product specifications and carry out your own checks. ' +
      'Office Furniture Tech accepts no responsibility for individual suitability of products shown here.</div>';

    /* Help bar */
    html += '<div style="display:flex;gap:8px;flex-wrap:wrap;padding-top:14px;border-top:1px solid #f0f0f0;margin-top:4px">' +
      '<a href="tel:+447459691324" style="display:inline-flex;align-items:center;gap:6px;background:#f5f5f5;color:#333;border:1px solid #e0e0e0;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;text-decoration:none">&#128222; Call us</a>' +
      '<a href="/pages/contact-us" style="display:inline-flex;align-items:center;gap:6px;background:#f5f5f5;color:#333;border:1px solid #e0e0e0;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:600;text-decoration:none">&#9993; Contact us</a>';
    if (answers['2'] === 'bulk' || answers['5'] === 'bulk') {
      html += '<a href="/pages/have-large-order" style="display:inline-flex;align-items:center;gap:6px;background:#df6060;color:#fff;border:1px solid #df6060;border-radius:8px;padding:8px 14px;font-size:12.5px;font-weight:700;text-decoration:none">Request Bulk Quote</a>';
    }
    html += '</div>';
    html += '<button onclick="oftWizReset();oftWizShowStep(1)" style="margin-top:14px;background:none;border:1.5px solid #ddd;border-radius:8px;padding:9px 16px;font-size:13px;color:#555;cursor:pointer;font-weight:600;font-family:inherit" type="button">&larr; Start again</button>';

    res.innerHTML = html;
    if (window.oftCmpRenderBar) window.oftCmpRenderBar();
  }

  /* ── Init ── */
  function init() {
    bindOptions();
    bindNav();

    /* Close on backdrop click */
    var overlay = document.getElementById('oft-wiz-overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) oftWizClose();
      });
    }

    /* Header button fix — override old onclick */
    var hBtn = document.getElementById('oft-header-wiz-btn');
    if (hBtn) {
      hBtn.onclick = null;
      hBtn.addEventListener('click', function () { oftWizOpen(); });
    }

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        oftWizClose();
        oftCmpCloseModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
